module.exports = __webpack_public_path__ + "img/551-42dfb3.png";